import React from 'react';

import { InputProps } from './Input';

import CountryField from 'components/Core/Payment/PaymentForm/Card/CountryField/CountryField';
import BaseInput from 'components/Shared/Inputs/BaseInput';
import { colors } from 'styles/cp';

export interface InputWithCountryFieldProps extends InputProps {
  country: Record<string, any>;
  cdn: string;
  updateCountry: (value: any) => void;
}

const InputWithCountryField: React.FC<InputWithCountryFieldProps> = ({
  isInError = false,
  children,
  height = 36,
  inputCustomStyling,
  theme,
  ariaLabel,
  cdn,
  country,
  updateCountry,
  ...rest
}) => {
  return (
    <React.Fragment>
      <div className="wrapper">
        <div className="input-with-country-field-wrapper">
          <div>
            <CountryField
              cdn={cdn}
              country={country}
              onChange={updateCountry}
              shouldFocus={false}
              showCountryCode={true}
            />
          </div>
          <BaseInput
            isInError={isInError}
            theme={theme}
            ariaLabel={ariaLabel}
            pattern="[0-9]*"
            {...rest}
          />
        </div>
        {children}
      </div>
      {/* language=scss */}
      <style jsx>{`
        .wrapper {
          display: flex;
          border: 1px solid ${isInError ? colors.error : colors.gray05};
          border-radius: 4px;
          ${inputCustomStyling || ''};
          min-height: ${height}px;
          transition: border 0.3s;

          &:hover {
            border: ${isInError ? `1px solid ${colors.error}` : `1px solid ${colors.green}`};
          }
          &:focus-within {
            border: ${isInError ? `1px solid ${colors.error}` : `2px solid ${colors.green}`};
          }
        }

        .input-with-country-field-wrapper {
          display: flex;
          width: 100%;
        }
      `}</style>
    </React.Fragment>
  );
};

export default InputWithCountryField;
